import React  from 'react';
import { Fragment, useState } from 'react'; //todo
import {
    Button,
    Confirm,
    useUpdateMany,
    useRefresh,
    useNotify,
    useUnselectAll,
} from 'react-admin';
import Icon from '@mui/material/Icon'

const ActionButton = ({ selectedIds,actData }) => {
    const [open, setOpen] = useState(false);
    const refresh = useRefresh();
    const notify = useNotify();
    const unselectAll = useUnselectAll('posts');

    const [updateMany, { isloading }] = useUpdateMany(
        `${actData.resources}`,
        {
         ids: selectedIds,
        data: { [actData.StateColumn]: actData.StateValue },
        },
        {
            onSuccess: () => {//todo
                refresh();
                notify(`${actData.alert_accept}`); //todo useNotify Now Takes An Options Object
                unselectAll(`${actData.Module}`);
            },
            onFailure: error => notify(`${actData.alert_error}`, 'warning'),//todo
        }
    );
    const handleClick = () => setOpen(true);
    const handleDialogClose = () => setOpen(false);

    const handleConfirm = () => {
        updateMany();
        setOpen(false);
    };

    return (
        <Fragment>
            <Button 
             variant="outlined"
             color="primary"
            label={actData.title} onClick={handleClick} />
          
            <Confirm
                isOpen={open}
                loading={isloading}
                title={actData.title}
                content="سيتم الامر علي السجلات المختارة وفى حالة الفشل فى احداها سيكمل النظام الامر علي بقية السجلات مع اخطاركم بفشل البعض"
                onConfirm={handleConfirm}
                onClose={handleDialogClose}
            />
        </Fragment>
    );
}

export default ActionButton;